import { render, staticRenderFns } from "./GSurveyChartLikert.vue?vue&type=template&id=5ef61d86&scoped=true&"
import script from "./GSurveyChartLikert.vue?vue&type=script&lang=ts&"
export * from "./GSurveyChartLikert.vue?vue&type=script&lang=ts&"
import style0 from "./GSurveyChartLikert.vue?vue&type=style&index=0&id=5ef61d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef61d86",
  null
  
)

export default component.exports